import React from 'react';
import Banner from '../components/Banner';
import { useTranslation } from 'react-i18next';
import Video from '../assets/BannerVideo2.mp4'
import OurService from '../components/OurService';
import ServiceHighlights from '../components/ServiceHighlights'

const Services = () => {
  const { t } = useTranslation();

  return (
    <div>
        <Banner videoSrc={Video} title={t('bannerTitleService')} bannerInfo={t('elevateWellnessJourney')} buttonText={t('bookAppointent')} />
        <OurService/>
        <ServiceHighlights/>
</div>
  );
};
 
export default Services;
